import * as React from 'react';
import { FiltersSearchButton } from '../FiltersSearchButton';
import styles from '../FiltersSearchButtons/FiltersSearchButtons.css';

export interface IFiltersMortgageButtonsProps {
  rightButtonHref: string;
  rightButtonTitle: string;
}

export class FiltersMortgageButtons extends React.Component<IFiltersMortgageButtonsProps> {

  public render() {
    const {rightButtonHref, rightButtonTitle} = this.props;

    return (
      <span className={styles['container']}>
        <FiltersSearchButton
          dataMark="FiltersMortgageRightButton"
          text={rightButtonTitle}
          title={rightButtonTitle}
          href={rightButtonHref}
        />
      </span>
    );
  }
}
